import React from 'react'
import { _preFormatDate } from '../../../../utils/validation';
import Ui from '../../../presentationals/Admin/Recovery/RAZORPAYData.component'
import Loader from '../../../presentationals/Loader/Loader.component'
import { getRazorpayData, getCashFreeReportDataFromDate } from '../../Admin/AdminActionCreator.component'
import { CheckFunction } from '../../../../layouts/MainTenantconfig';

class Razor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Start: '',
            End: '',
            startDate: _preFormatDate(new Date()),
            endDate: _preFormatDate(new Date()),
            loaderState: false,
            reporttype: "razorpay"
        }
    }
    dateChangeHandler(e, type) {
        if (type === 'start') {
            this.setState({ startDate: _preFormatDate(e), Start: e })
        }
        if (type === 'end') {
            this.setState({ endDate: _preFormatDate(e), End: e })

        }
        if (type === 'type') {
            this.setState({ reporttype: e.target.value })

        }

    }
    downloadreport() {
        
        if (this.state.reporttype == "razorpay") {
            this.setState({ loaderState: true })
            getRazorpayData(this.state.startDate, this.state.endDate, callBack => {
                if (callBack !== '') {
                    this.setState({ loaderState: false })
                }
            })
        } else if (this.state.reporttype == "cashfree") {
            this.setState({ loaderState: true })
            getCashFreeReportDataFromDate(this.state.startDate, this.state.endDate, callBack => {
                if (callBack !== '') {
                    this.setState({ loaderState: false })
                }
            })
        }
    }
    render() {
        const tenant = CheckFunction()
        return (
            <div>
                {this.state.loaderState ?
                    <Loader />
                    : ""}
                <Ui
                    downloadreport={this.downloadreport.bind(this)}
                    Start={this.state.Start}
                    End={this.state.End}
                    dateChangeHandler={this.dateChangeHandler.bind(this)}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    reporttype={this.state.reporttype}
                    tenant={tenant}

                />
            </div>
        )
    }
}
export default Razor